import { render, staticRenderFns } from "./MobileFavouriteStockItem.vue?vue&type=template&id=6d2c9310&scoped=true"
import script from "./MobileFavouriteStockItem.vue?vue&type=script&lang=js"
export * from "./MobileFavouriteStockItem.vue?vue&type=script&lang=js"
import style0 from "./MobileFavouriteStockItem.vue?vue&type=style&index=0&id=6d2c9310&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c9310",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2c9310')) {
      api.createRecord('6d2c9310', component.options)
    } else {
      api.reload('6d2c9310', component.options)
    }
    module.hot.accept("./MobileFavouriteStockItem.vue?vue&type=template&id=6d2c9310&scoped=true", function () {
      api.rerender('6d2c9310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/MobileFavouriteStockItem.vue"
export default component.exports